module.exports = __webpack_public_path__ + "static/assets/b738694166b61cbe00e5cd96590947ad.png";